"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.readyStates = exports.readyStateText = exports.PROTOCOLS_WS = exports.PROTOCOLS = void 0;
const readyStateText = exports.readyStateText = {
  '-1': 'UNINSTANTIATED',
  0: 'CONNECTING',
  1: 'OPEN',
  2: 'CLOSING',
  3: 'CLOSED'
};
const readyStates = exports.readyStates = {
  CONNECTING: 0,
  OPEN: 1,
  CLOSING: 2,
  CLOSED: 3
};
const PROTOCOLS = exports.PROTOCOLS = {
  HTTPS: 'https',
  HTTP: 'http'
};
const PROTOCOLS_WS = exports.PROTOCOLS_WS = {
  WSS: 'wss',
  WS: 'ws'
};